import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import { registerGuard } from './router-guard'
import IdentityCallback from '@/views/authentication/IdentityCallback.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/keys',
    },
    {
      path: '/keys',
      component: DefaultLayout,
      children: [
        {
          path: '',
          name: 'keys',
          meta: {
            title: 'API Keys',
          },
          component: () => import('@/views/ApiKeysView.vue'),
        },
      ],
    },
    {
      path: '/identity/callback',
      component: AuthLayout,
      children: [
        {
          path: '',
          name: 'identityCallback',
          component: IdentityCallback,
        },
      ],
    },
    {
      path: '/signin/error',
      name: 'signinError',
      component: () => import('@/views/authentication/SigninError.vue'),
      meta: {
        title: 'Signin Error',
        allowAnonymous: true,
      },
    },
  ],
})

registerGuard(router)

export default router
